import React, { useState, useRef, useEffect } from 'react';
import { LineChart } from 'lucide-react';

const INDICATORS = [
  { key: 'SMA', label: 'SMA' },
  { key: 'EMA', label: 'EMA' },
  { key: 'RSI', label: 'RSI' },
  { key: 'BollingerBands', label: 'Bollinger Bands' },
];

const IndicatorSelector = ({ activeIndicators, onToggle, onClear, showVolume, onToggleVolume }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const activeCount = Object.values(activeIndicators).filter(Boolean).length + (showVolume ? 1 : 0);

  return (
    <div ref={dropdownRef} style={{ position: 'relative' }}>
      <button 
        className="toolbar-dropdown-btn" 
        onClick={() => setIsOpen(!isOpen)}
        title="Indicators"
      >
        <LineChart size={16} />
        <span>Indicators</span>
        {activeCount > 0 && <span className="active-badge">{activeCount}</span>}
      </button>

      {isOpen && (
        <div className="toolbar-dropdown-menu">
          {INDICATORS.map(({ key, label }) => (
            <div
              key={key}
              className={`dropdown-item ${activeIndicators[key] ? 'active' : ''}`}
              onClick={() => onToggle(key)}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <span>{label}</span>
                {activeIndicators[key] && <span style={{ color: '#0ecb81' }}>✓</span>}
              </div>
            </div>
          ))}
          
          <div className="dropdown-divider"></div>
          <div
            className={`dropdown-item ${showVolume ? 'active' : ''}`}
            onClick={onToggleVolume}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <span>Volume</span>
              {showVolume && <span style={{ color: '#0ecb81' }}>✓</span>}
            </div>
          </div>
          
          {Object.values(activeIndicators).filter(Boolean).length > 0 && (
            <>
              <div className="dropdown-divider"></div>
              <div
                className="dropdown-item clear-all"
                onClick={() => {
                  onClear();
                  setIsOpen(false);
                }}
              >
                Clear all indicators
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default IndicatorSelector;
